module.exports = __webpack_public_path__ + "static/media/add_circle.fa584bbd.svg";